import { Mesh, Object3D, Vector2, Vector3 } from "three";

import { MeshLineGeometry, MeshLineMaterial } from "meshline";

export class ActorTrack extends Object3D {
  trackId: number;

  private points: Vector3[];
  private maxPoints: number;
  private height?: number;

  static pointThreshold = 0.15;

  private mesh: Mesh;
  private line: MeshLineGeometry;

  private widthCb = (p: number) => p;

  constructor(
    id: number,
    resolution: Vector2,
    height?: number,
    color?: number,
    maxPoints = 250
  ) {
    super();

    this.trackId = id;
    this.maxPoints = maxPoints;
    this.height = height;

    // TODO: make this circular??
    this.points = [];

    const lineMat = new MeshLineMaterial({
      color: color ?? Math.random() * 0xffffff,
      lineWidth: 1,
      resolution,
    });
    this.line = new MeshLineGeometry();

    this.mesh = new Mesh(this.line, lineMat);
    this.mesh.frustumCulled = false;
    this.add(this.mesh);
  }

  update(centroid: Vector3) {
    const head = this.points[this.points.length - 1];
    if (
      head !== undefined &&
      head.distanceTo(centroid) < ActorTrack.pointThreshold
    ) {
      return;
    }

    const pos = centroid.clone();
    if (this.height) pos.y = this.height;
    this.points.push(pos);

    // TODO: use circular buffer???
    if (this.points.length >= this.maxPoints) {
      this.points.shift();
      this.line.advance(pos);
    } else {
      this.line.setPoints(this.points, this.widthCb);
    }
  }
}
